import { createTheme } from '@mui/material/styles';
import { huHU } from '@mui/material/locale';

/**
 * A felület magyar (spec 17.1 §: „A felület elsődlegesen magyar nyelvű
 * legyen") — a MUI saját szövegeit (lapozó, autocomplete, táblázat) a `huHU`
 * locale adja, hogy ne maradjanak angol szigetek a magyar felületen.
 *
 * A projektnek nincs design systeme és nincs megadott színpalettája, ezért
 * a MUI alapértelmezéseihez nyúlunk, egyetlen szándékos eltéréssel: sűrűbb
 * elrendezés, mert ez egy adatsűrű, íróasztali admin felület, nem
 * marketingoldal.
 */
export const theme = createTheme(
  {
    palette: {
      mode: 'light',
    },
    typography: {
      fontSize: 14,
    },
    components: {
      MuiTable: { defaultProps: { size: 'small' } },
      MuiTextField: { defaultProps: { size: 'small' } },
      MuiButton: { defaultProps: { disableElevation: true } },
    },
  },
  huHU,
);
